import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { defaultKSK2090_R01Filter, useKSK2090_R01Store } from "./Store_KSK2090_R01";



	export const SearchSection_KSK2090_R01 = () => {

	const { brandCdList, itemGroupList, itemAccountList } = useCommonCodeStore();
	const { KSK2090_R01Filter, setKSK2090_R01Filter } = useKSK2090_R01Store();

	const { setCodeSearchModalProps } = useUiuxStore();

	const prntItemcdHandleFoucsId = 'prntItemcd_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'prntItemcd',
			category: 'BOM_모품목',
			focusId: prntItemcdHandleFoucsId,
			responseMapping: {
				prntItemcd: 'prntItemcd',
				itemNm: 'prntItemnm',
			},
			extraFilter: () => ({
				prntItemcd: KSK2090_R01Filter.prntItemcd || '',
				prntItemnm: KSK2090_R01Filter.prntItemnm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: KSK2090_R01Filter,
		setEditData: setKSK2090_R01Filter,
		defaultData: defaultKSK2090_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'KSK2090_R01_search'
	});

	return (
		<SearchSectionForm>
			{/* KSK2090_R01Filter: {JSON.stringify(KSK2090_R01Filter)} */}
			<SearchCodeModalForm
				label="모품목코드"
				value={KSK2090_R01Filter.prntItemcd}
				valueLabel={KSK2090_R01Filter.prntItemnm}
				handleFoucsId={prntItemcdHandleFoucsId}
				onChange={getFieldHandlers('prntItemcd').onChange}
				onDoubleClick={getFieldHandlers('prntItemcd').onDoubleClick}
				onKeyDown={getFieldHandlers('prntItemcd').onEnterKeyDown}
				wrapperOption={{
					wrapperStyle: "w-[500px] min-w-[500px] mr-[10px] mb-[5px]",
					titleStyle: "w-[90px] min-w-[90px] text-left",
					codeInputStyle: "w-[190px] min-w-[190px]",
					nameTagStyle: "w-[300px] min-w-[300px] text-left",
				}}
			/>

		</SearchSectionForm>
	)
	}